import { UploadFile } from '../../../../../pages/user-page/pages/docs/componenets/upload-file/upload-file';
import { Dialog } from 'primereact/dialog';
import React, { useState } from 'react';
import { FileUploadFile } from 'primereact/fileupload';
import { Button } from 'primereact/button';
import { updateAvatarOperations } from './operations/update-avatar-operations';
import { UserSummaryType } from '../../../../../api/types/user/user-summary.type';
import { toast } from 'react-toastify';

interface UpdateAvatarFileDialogDatamodel {
  userId: number | undefined;
  addAvatar: boolean;
  setAddAvatar: (addAvatar: boolean) => void;
  setSelectedUser: (user: UserSummaryType) => any;
  shouldUploadFile: boolean;
  setFile?: (file: FileUploadFile) => any;
  onFinishUploadFile?: () => any;
}

export const UpdateAvatarFileDialog: React.FC<
  UpdateAvatarFileDialogDatamodel
> = ({
  userId,
  addAvatar,
  setAddAvatar,
  setSelectedUser,
  shouldUploadFile = false,
  setFile,
  onFinishUploadFile,
}) => {
  const [uploadedFile, setUploadedFile] = useState<FileUploadFile>();

  const handleUpdateAvatar = async () => {
    if (shouldUploadFile) {
      toast.warn('asd');
      await updateAvatarOperations(userId, uploadedFile, setSelectedUser);
      onFinishUploadFile && onFinishUploadFile();
    }

    if (uploadedFile && setFile) {
      setFile(uploadedFile);
    }
  };
  return (
    <Dialog
      showHeader={true}
      header={'העלאת תמונה'}
      visible={addAvatar}
      style={{
        width: '400px',
        maxWidth: '400px',
        borderRadius: '8px',
        padding: '0px',
      }}
      contentStyle={{
        padding: '0', // Remove default padding if needed
      }}
      headerStyle={{
        color: 'black',
      }}
      onHide={() => {
        setAddAvatar(false);
      }}
    >
      <div style={{}}>
        <UploadFile onFileUploaded={setUploadedFile} />
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '8px',
        }}
      >
        <Button
          style={{ height: '30px', marginTop: '8px' }}
          label={'אישור'}
          onClick={handleUpdateAvatar}
        />
      </div>
    </Dialog>
  );
};
